module.exports = __webpack_public_path__ + "static/heavy_ugl1-46b0f0a469141aa75aac062cb1ab4493.jpg";